module.exports = __webpack_public_path__ + "img/ic_arrowback.660f5ea6.svg";